import { AxiosInstance } from 'axios'

export abstract class ApiPlugin {
  abstract initialize(axios: AxiosInstance): void
}
